import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useRequest } from 'hooks';

import { Title } from 'components/Misc/Typography';
import { Form, Input, Button } from 'components/Misc/Form';

import { useBlankProfileStore } from 'store/blank/useBlankProfileStore';
import { useBlankEditStore } from 'store/blank/useBlankEditStore';

const Edit = () => {
	// Cache current blank's id
	const { id } = useParams();

	// Use blank's profile store
	const [original, onUpdate] = useBlankProfileStore(state => [state.blank, state.onUpdate]);

	// Use blank's edit store
	const [blank, onChange, onInit, onReset] = useBlankEditStore(state => [
		state.blank,
		state.onChange,
		state.onInit,
		state.onReset
	]);

	// Store request
	const [[progress], request] = useRequest('put', `blanks/${id}`);

	// Initialize blank's data
	useEffect(() => {
		if (original) onInit(original);

		// Reset blank's data on unmount
		return () => onReset();
	}, [original]);

	// Handles form's onSubmit event
	// @event: object | onSubmit event
	const onSubmit = async event => {
		event.preventDefault();

		// Try to update blank's data
		const [success, error] = await request(blank);

		// Update blank's data
		if (success) return onUpdate(blank);

		// TODO: Think of a better way of handling errors
		if (error) console.log(error);
	};

	return (
		<Form
			onSubmit={onSubmit}
			className="mt-4 p-4 grid grid-cols-2 gap-4 bg-white dark:bg-neutral-800 rounded-lg transition-colors"
		>
			<Title
				title="Labot datus"
				className="col-span-2 text-xl"
			/>

			<Input
				type="text"
				name="title"
				label="Nosaukums"
				value={blank.title}
				onChange={onChange}
			/>

			{/* <Select
				name="gradeId"
				label="Klase"
				placeholder=" "
				value={blank.gradeId}
				onChange={onChange}
				options={grades?.map(grade => ({
					value: grade.id,
					name: grade.title
				}))}
			/> */}

			<div className="col-span-2 flex justify-end">
				<Button
					submit
					icon="done"
					value="Saglabāt"
					theme="success"
					progress={progress}
				/>
			</div>
		</Form>
	);
};

export default Edit;
